import { Form } from '@unform/web';
import styled from 'styled-components';

export const SelectedPlanContainer = styled.div`
  background: ${({ theme }) => theme.colors.lightBlue};
  padding: 20px 24px;
  border-radius: 15px;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  margin-top: 21px;

  span {
    font-weight: 700;
    font-size: 20px;
    color: ${({ theme }) => theme.colors.darkBlue2};
  }
`;

export const PlanInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;

  span {
    font-weight: 500;
    font-size: 12px;
    color: ${({ theme }) => theme.colors.darkBlue2};
  }

  .timeFrame {
    font-weight: 700;
    font-size: 16px;
    color: ${({ theme }) => theme.colors.darkBlue2};
  }
`;

export const PlanPriceContainer = styled.div`
  display: flex;
  flex-direction: column;

  span {
    font-weight: 400;
    font-size: 10px;
    color: ${({ theme }) => theme.colors.darkBlue2};
    line-height: 13px;
    text-align: right;
  }

  .highlightedText {
    font-weight: 600;
    font-size: 10px;
    color: ${({ theme }) => theme.colors.darkBlue2};
    line-height: 13px;
    text-align: right;
  }
`;

export const PriceContainer = styled.div`
  padding: 8px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.darkBlue2};
  background: ${({ theme }) => theme.colors.white};
  margin-bottom: 4px;

  span {
    font-weight: 700;
    font-size: 16px;
    color: ${({ theme }) => theme.colors.darkBlue2};
  }

  .smallText {
    font-size: 10px;
  }
`;

export const PaymentMethodContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  margin: 65px 0 23px 0;
  max-width: 450px;
`;

export const SelectedPaymentMethod = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 13px;

  span {
    font-size: 18px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.grey};
  }

  svg {
    color: ${({ theme }) => theme.colors.grey1};
  }
`;

export const ChangeMethodContainer = styled.div`
  cursor: pointer;

  span {
    font-size: 12px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.primary};
    text-decoration: underline;
  }
`;

export const ContainerForm = styled(Form)`
  h2 {
    margin: 40px 0px;
    font-weight: 600;
    font-size: 18px;
    color: ${({ theme }) => theme.colors.grey};
  }

  max-width: 450px;
`;

export const LineInputOne = styled.div`
  display: flex;
  align-items: flex-end;

  width: 100%;

  > div {
    & + div {
      margin-left: 30px;
    }
  }
`;

export const AddressCheckBoxContainer = styled.div`
  display: flex;
  align-items: center;

  span {
    margin-left: 10px;
    font-size: 15px;

    a {
      font-weight: 600;
      color: ${props => props.theme.colors.primary};
      text-decoration: none;
      margin: 0 4px;
    }
  }
`;

export const LineInputTwo = styled.div`
  display: flex;
  align-items: flex-end;

  > div {
    &:first-child {
      max-width: 130px;
    }

    & + div {
      flex: 1;
      margin-left: 30px;
    }
  }
`;

export const LineInputThree = styled.div`
  display: flex;
  align-items: flex-end;

  > div {
    &:first-child {
      max-width: 210px;
    }

    & + div {
      flex: 1;
      margin-left: 30px;
    }
  }
`;
